import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import SelectInput from '../../components/inputs/select'
import DatePickerInput from '../../components/inputs/date-picker'
import Button from 'react-bootstrap/Button'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import DeleteModal from '../../components/delete-dialog'
import {
  getWorkHourSettings,
  assignWorkHourSetting,
  getUserWorkHourAssignment,
  getUserWorkHourAssignmentHistory,
  deleteWorkHourAssignment,
} from '../../actions/work-hour-settings.action'
import { getUserNames } from '../../actions/user-management.action'
import { errorSnackBar } from '../../actions/common.action'
import './scss/work-hour-settings.scss'
import moment from 'moment'

class WorkHourAssignmentSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeSettings: [],
      currentAssignment: null,
      history: [],
      userNameMap: {},
      confirmDeleteId: null,
      selectedSettingId: '',
      effectiveDate: moment().toISOString(),
      assigning: false,
      settingError: '',
      dateError: '',
    }
  }

  componentDidMount() {
    this.loadData()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userId !== this.props.userId) {
      this.loadData()
    }
  }

  loadData = () => {
    const { userId } = this.props
    if (!userId) return

    this.props.getWorkHourSettings().then((result) => {
      const all = Array.isArray(result) ? result : (result?.data || [])
      this.setState({ activeSettings: all.filter((s) => s.is_active) })
    }).catch(() => {})

    this.props.getUserWorkHourAssignment(userId).then((result) => {
      const assignment = result?.data || result || null
      this.setState({ currentAssignment: assignment })
    }).catch(() => {
      this.setState({ currentAssignment: null })
    })

    this.props.getUserWorkHourAssignmentHistory(userId).then((result) => {
      const list = Array.isArray(result) ? result : (result?.data || [])
      this.setState({ history: list })
    }).catch(() => {})

    this.props.getUserNames().then((result) => {
      const users = Array.isArray(result) ? result : []
      const map = {}
      users.forEach((u) => {
        map[u.id] = [u.firstName, u.lastName].filter(Boolean).join(' ')
      })
      this.setState({ userNameMap: map })
    }).catch(() => {})
  }

  handleAssign = () => {
    const { selectedSettingId, effectiveDate } = this.state
    const { userId } = this.props

    let valid = true
    if (!selectedSettingId) {
      this.setState({ settingError: 'Please select a Work Hour Setting' })
      valid = false
    }
    if (!effectiveDate || !moment(effectiveDate).isValid()) {
      this.setState({ dateError: 'Please select a valid effective date' })
      valid = false
    }
    if (!valid) return

    this.setState({ assigning: true })
    this.props.assignWorkHourSetting({
      target_user_id: userId,
      work_hour_setting_id: selectedSettingId,
      effective_date: moment(effectiveDate).format('YYYY-MM-DD'),
    }).then(() => {
      this.setState({ assigning: false, selectedSettingId: '', effectiveDate: moment().toISOString() })
      this.loadData()
    }).catch(() => {
      this.setState({ assigning: false })
    })
  }

  handleDeleteAssignment = (id) => {
    this.setState({ confirmDeleteId: id })
  }

  confirmDelete = (id) => {
    this.setState({ confirmDeleteId: null })
    this.props.deleteWorkHourAssignment(id).then(() => {
      this.loadData()
    }).catch(() => {})
  }

  render() {
    const {
      activeSettings,
      currentAssignment,
      history,
      userNameMap,
      confirmDeleteId,
      selectedSettingId,
      effectiveDate,
      assigning,
      settingError,
      dateError,
    } = this.state
    const { writePermission, userId } = this.props

    if (!userId) return null

    const settingItems = activeSettings.map((s) => ({ value: s.id, key: s.name }))

    return (
      <div className="work-hour-settings assignment-section mt-4" data-cy="work-hour-assignment-section">
        <div className="col-12 my-2"><hr /></div>
        <h2 className="content-heading content-heading-sm text-uppercase my-auto me-auto mb-3">
          Work Hour Setting
        </h2>

        <div className="mb-3">
          {currentAssignment && currentAssignment.workHourSetting ? (
            <span className="current-assignment-badge" data-cy="current-assignment-badge">
              Currently assigned: <strong>{currentAssignment.workHourSetting.name}</strong>
              {currentAssignment.effective_date && (
                <> (effective {moment(currentAssignment.effective_date).format('D MMM YYYY')})</>
              )}
            </span>
          ) : (
            <span className="no-assignment-text" data-cy="no-assignment-text">
              No work hour setting assigned yet.
            </span>
          )}
        </div>

        {writePermission && (
          <div className="row" data-cy="assign-work-hour-form">
            <div className="col-lg-4 col-md-6 mt-2">
              <SelectInput
                label="Work Hour Setting"
                name="work_hour_setting_id"
                value={selectedSettingId}
                items={settingItems}
                placeholder="Work Hour Setting"
                onChange={(e) => this.setState({ selectedSettingId: e.target.value, settingError: '' })}
                validation={['required']}
                dataCy="work-hour-setting-select"
                error={settingError}
                touched={!!settingError}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-2">
              <DatePickerInput
                label="Effective Date"
                value={effectiveDate}
                onChange={(val) => this.setState({ effectiveDate: val, dateError: '' })}
                validation={['required']}
                dataCy="effective-date-picker"
                error={dateError}
                touched={!!dateError}
              />
            </div>
            <div className="col-lg-4 col-md-6 mt-2 d-flex align-items-end mb-1">
              <Button
                variant="primary"
                className="secondarybtn"
                onClick={this.handleAssign}
                disabled={assigning}
                data-cy="assign-work-hour-btn"
              >
                {assigning ? 'Assigning…' : 'Assign Setting'}
              </Button>
            </div>
          </div>
        )}

        {history.length > 0 && (
          <div className="mt-4" data-cy="assignment-history-table">
            <h2 className="content-heading content-heading-sm text-uppercase mb-2">
              Assignment History
            </h2>
            <div className="table-responsive">
              <table className="table table-bordered history-table">
                <thead>
                  <tr>
                    <th>Setting Name</th>
                    <th>Effective Date</th>
                    <th>Status</th>
                    <th>Assigned By</th>
                    {writePermission && <th />}
                  </tr>
                </thead>
                <tbody>
                  {history.map((item) => (
                    <tr key={item.id} data-cy={`history-row-${item.id}`}>
                      <td>{item.workHourSetting?.name || '—'}</td>
                      <td>
                        {item.effective_date
                          ? moment(item.effective_date).format('DD/MM/YYYY')
                          : '—'}
                      </td>
                      <td>
                        <span className={`status-pill ${item.is_active ? 'current' : 'past'}`}>
                          {item.is_active ? 'Current' : 'Past'}
                        </span>
                      </td>
                      <td>{userNameMap[item.created_by] || '—'}</td>
                      {writePermission && (
                        <td style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>
                          <DeleteOutlineOutlinedIcon
                            className="delete-icon"
                            style={{ cursor: 'pointer' }}
                            onClick={() => this.handleDeleteAssignment(item.id)}
                            data-cy={`delete-assignment-${item.id}`}
                          />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <DeleteModal
          open={!!confirmDeleteId}
          dialogClose={() => this.setState({ confirmDeleteId: null })}
          deleteHandler={this.confirmDelete}
          id={confirmDeleteId}
          moduleName="Assignment"
          description="this assignment"
          dataCy="delete-assignment-modal"
        />
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getWorkHourSettings,
      assignWorkHourSetting,
      getUserWorkHourAssignment,
      getUserWorkHourAssignmentHistory,
      deleteWorkHourAssignment,
      getUserNames,
      errorSnackBar,
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(WorkHourAssignmentSection)
